<template>
  <!-- Nested inside the Register Player modal: both dialogs are z-[10000]
       Headless UI dialogs; this later-mounted one stacks above (Phase 1
       convention, bug 1.3 fix). -->
  <Dialog :expanderClass="'d-inline'" ref="player" panelClass="bui-dialog-panel">
    <template #expander="{ openModal }">
      <ButtonCustomized :label="btnTitle" :primary="primary" :cta="cta" data-testid="player-select-location" @click="openModal" v-if="showBtn" />
      <button type="button" data-testid="player-select-location" @click="openModal" v-if="!showBtn" class="change-link">Change</button>
    </template>
    <template #dialog.title>
      Select Location
    </template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <div>
        <SimpleEntityListingPage
          entityItemsNamePlural=""
          entityItemName="Location"
          areaAccessName="Administration"
          :ItemsLister="LocationsLister"
          :singleSelect="true"
        />

        <div class="form-buttons">
          <ButtonCustomized label="Add" data-testid="location-add" cta @click="onSave" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import Dialog from '../../../components/Dialog/Dialog.vue';
import ButtonCustomized from "../../../components/form-fields/ButtonCustomized.vue";
import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
import LocationsLister from '../../SettingsViews/LocationsListView/LocationsLister/LocationsLister.vue';
import useListSelection from '@/components/ListingPages/ItemsLister/ItemsList/composables/listSelection';
import { ref } from 'vue';
const player = ref()
const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
defineProps({
  'showBtn': {
    type: Boolean,
    default: true
  },
  'btnTitle': {
    type: String,
    default: 'Select Location'
  },
  /** Pass-through for ButtonCustomized's pink brand variant. */
  'primary': {
    type: Boolean,
    default: false
  },
  /** Pass-through for ButtonCustomized's BUI lemonlime CTA variant. */
  'cta': {
    type: Boolean,
    default: false
  }

})
const {
  selectedItemsIds,
  selectedItems,
  clearItemsSelection
} = useListSelection({
  clearSelectionTriggerElement: document.body
});

function onExit() {
  emit('exit')
}
async function onSave() {
  emit('save', selectedItems[0]);
  clearItemsSelection();
  player.value.closeModal()
}

</script>

<style lang="scss" scoped>
.button {
  cursor: pointer;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.change-link {
  display: inline-block;
  padding: 0;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--bui-tbl-row-link, #4b1886);
  cursor: pointer;
}

.change-link:hover {
  text-decoration: underline;
}
</style>
